import $ from 'jquery';

export default class VideoLoop {
	constructor() {
		this.elements = {
			videoLoops: $( '.ncst-video-loop-container' ),
		};

		this.loops = [];
	}

	init() {
		var self = this;

		if ( this.elements.videoLoops.length === 0 ) {
			return;
		}

		//retrieve cookies for any existing videos and set initial pause state
		this.elements.videoLoops.each( ( index, container ) => {
			var $video = $( container ).find( 'video' );
			var $toggle = $( container ).find( '.ncst-video-loop-toggle' );
			var cookie_id = this.getCookieId( $video[ 0 ] );
			var set_to_paused = this.getCookie( cookie_id );
			var targetId = this.loops.length;

			$toggle.attr( 'data-ncst-video-loop', targetId );
			this.loops.push( $video[ 0 ] );

			if ( set_to_paused ) {
				this.handleVideoToggle( $video[ 0 ], $toggle[ 0 ] );
			}
		} );

		//setup listeners for button interactions
		$( '.ncst-video-loop-toggle' ).click( function ( e ) {
			e.preventDefault();
			self.handleVideoToggle(
				self.loops[ this.getAttribute( 'data-ncst-video-loop' ) ],
				this
			);
		} );
	}

	getCookieId( video ) {
		var src = video.firstElementChild.getAttribute( 'src' );
		return src.substring(
			src.lastIndexOf( '/' ) + 1,
			src.lastIndexOf( '.' )
		);
	}

	getCookie( cname ) {
		var name = cname + '=';
		var decodedCookie = decodeURIComponent( document.cookie );
		var ca = decodedCookie.split( ';' );
		for ( var i = 0; i < ca.length; i++ ) {
			var c = ca[ i ];
			while ( c.charAt( 0 ) == ' ' ) {
				c = c.substring( 1 );
			}
			if ( c.indexOf( name ) == 0 ) {
				return c.substring( name.length, c.length );
			}
		}
		return '';
	}

	handleVideoToggle( video, toggle ) {
		var cookie_id = this.getCookieId( video );

		var expires = new Date(),
			current_text = toggle.innerText || toggle.textContent;
		if ( current_text === 'Stop Video' ) {
			video.pause();
			expires.setTime( expires.getTime() + 365 * 24 * 60 * 60 * 1000 );
			document.cookie =
				cookie_id + '=1; expires=' + expires.toUTCString();
			toggle.innerText = 'Play Video';
		} else {
			video.play();
			expires.setTime( expires.getTime() - 1000 );
			document.cookie =
				cookie_id + '=0; expires=' + expires.toUTCString();
			toggle.innerText = 'Stop Video';
		}
	}
}
